(function () {
  'use strict';

  var DEFAULT_SIZE_STATS = {
    '01': { pieces: 32, daily: 8 },
    '02': { pieces: 30, daily: 7 },
    '03': { pieces: 26, daily: 6 },
    '04': { pieces: 24, daily: 6 },
    '05': { pieces: 22, daily: 5 },
    '06': { pieces: 20, daily: 5 }
  };

  function formatMoney(cents, format) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents, format || window.theme.moneyFormat);
    }

    return (cents / 100).toFixed(2);
  }

  function isGiftPersonName(value) {
    var trimmed = String(value || '').trim();
    if (trimmed.length < 2) return false;
    if (/\d/.test(trimmed) || /@/.test(trimmed)) return false;
    return /^[\p{L}][\p{L}\s.'’-]*$/u.test(trimmed);
  }

  function isGiftEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(String(value || '').trim());
  }

  function isGiftPhone(value) {
    var trimmed = String(value || '').trim();
    if (!trimmed) return true;
    var digits = trimmed.replace(/\D/g, '');
    if (digits.length < 8 || digits.length > 15) return false;
    return /^[+\d][\d\s()./-]*$/.test(trimmed);
  }

  function isGiftCity(value) {
    var trimmed = String(value || '').trim();
    if (trimmed.length < 2) return false;
    if (/\d/.test(trimmed) || /@/.test(trimmed)) return false;
    // Allow names like "Den Bosch" and "'s-Hertogenbosch"
    if (!/[\p{L}]/u.test(trimmed)) return false;
    return /^[\p{L}'’][\p{L}\s.'’\-–,()/]*$/u.test(trimmed);
  }

  function isGiftAddress(value) {
    var trimmed = String(value || '').trim();
    if (trimmed.length < 3) return false;
    if (/@/.test(trimmed)) return false;
    return /[\p{L}]/u.test(trimmed);
  }

  function isGiftPostal(value, isNetherlands) {
    var trimmed = String(value || '').trim();
    if (!trimmed) return false;
    if (isNetherlands) {
      return /^[1-9][0-9]{3}\s?[A-Za-z]{2}$/.test(trimmed);
    }
    return /^[A-Za-z0-9][A-Za-z0-9\s-]{1,10}$/.test(trimmed);
  }

  function normalizeSizeKey(value) {
    if (value == null || value === '') return '';

    var match = String(value).match(/(\d{1,2})/);
    if (!match) return '';

    var key = match[1];
    return key.length === 1 ? '0' + key : key.slice(-2);
  }

  function inferPackCount(label) {
    if (!label) return null;

    var text = String(label).toLowerCase();
    var packMatch = text.match(/(\d+)\s*-?\s*(pack|verpakking|paket|paquete|pak)\b/);
    if (packMatch) return parseInt(packMatch[1], 10);

    if (/trial|starter|proef|probe|prozess|prueba/.test(text)) return 1;
    if (/duo|everyday/.test(text)) return 2;
    if (/supply|aanbod|vorrat|lieferung|suministro/.test(text)) return 4;
    if (/monthly|full|\bvoll?\b|completo/.test(text)) return 6;

    return null;
  }

  function recommendedWeeksFromPackCount(packCount) {
    var packs = parseInt(packCount, 10);
    if (packs >= 6) return 3;
    return 2;
  }

  function parseWeeksFromPlanName(name) {
    var text = String(name || '').toLowerCase().split(' - ')[0];
    var everyMatch = text.match(/every\s+(\d+)\s*weeks?/);
    if (everyMatch) return parseInt(everyMatch[1], 10);

    var tokens = ['12', '8', '6', '4', '3', '2'];
    var i;

    for (i = 0; i < tokens.length; i += 1) {
      if (text.indexOf(tokens[i]) !== -1) return parseInt(tokens[i], 10);
    }

    var match = text.match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function parseGiftMonths(value) {
    const match = String(value || '').match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function isJuoRecurringPlan(plan) {
    if (!plan || !plan.id) return false;
    // Juo fixed child plans are named with a trailing space (e.g. "… 2 cycles ").
    return String(plan.name || '').trim() === String(plan.name || '');
  }

  function getOptionFieldsets(root) {
    if (!root) return [];
    const block = root.closest ? root.closest('product-information-block') : null;
    const scope = block || root;
    return Array.from(scope.querySelectorAll('fieldset[data-option-position]'));
  }

  function getSelectedOptions(block) {
    const variantSelects = (block.getActiveVariantSelects && block.getActiveVariantSelects())
      || block.querySelector('variant-selects');
    if (!variantSelects && !block.querySelector) return {};

    const isSubscription = block.isSubscription && block.isSubscription();
    const options = {};
    const fieldsets = getOptionFieldsets(block);

    fieldsets.forEach(function (fieldset) {
      const input = fieldset.querySelector('input[type="radio"]:checked');
      if (!input || input.disabled) return;

      const packageItem = input.closest('[data-package-value]');
      if (
        isSubscription
        && packageItem
        && packageItem.dataset.availableForSubscription !== 'true'
      ) {
        return;
      }

      options[input.name] = input.value;
    });

    return options;
  }

  function findVariantForOptions(variants, selectedOptions, variantSelects) {
    if (!variants.length) return null;

    const fieldsets = getOptionFieldsets(variantSelects);

    if (fieldsets.length) {
      return variants.find(function (variant) {
        return fieldsets.every(function (fieldset) {
          const position = parseInt(fieldset.dataset.optionPosition, 10);
          const input = fieldset.querySelector('input[type="radio"]');
          if (!input || !position) return true;

          const selected = selectedOptions[input.name];
          if (selected == null) return true;

          return variant['option' + position] === selected;
        });
      });
    }

    if (!variantSelects) return null;

    const orderedNames = [];
    variantSelects.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (!orderedNames.includes(input.name)) orderedNames.push(input.name);
    });

    return variants.find(function (variant) {
      return orderedNames.every(function (name, index) {
        const selected = selectedOptions[name];
        if (selected == null) return true;
        return variant['option' + (index + 1)] === selected;
      });
    });
  }

  function getVariantForPackageValue(variants, packageValue, selectedOptions, variantSelects, packageInput) {
    const options = Object.assign({}, selectedOptions);
    if (packageInput) {
      options[packageInput.name] = packageValue;
    }

    return findVariantForOptions(variants, options, variantSelects);
  }

  class ProductInformationBlock extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.hasSubscriptions = this.dataset.hasSubscriptions === 'true';
      this.defaultPurchaseType = this.dataset.defaultPurchaseType || 'one_time';
      this.moneyFormat = this.dataset.moneyFormat;

      this.variantSelects = this.querySelector('variant-selects');
      this.deliveryFieldset = this.querySelector('[data-delivery-fieldset]');
      this.sizeFieldset = this.querySelector('[data-size-fieldset]');
      this.purchaseTypeInputs = this.querySelectorAll('[data-purchase-type]');
      this.deliveryInputs = this.querySelectorAll('[data-delivery-input]');
      this.refreshPackageItems();
      this.sellingPlanInput = this.getSellingPlanInput();

      this.variants = [];
      this.sellingPlansMap = {};

      this.parseData();
      this.bindEvents();
      this.initRoutineUpsell();
      this.initGiftDate();
      this.initGiftDrawer();
      this.initClaimGift();
      this.lockDeliveryOptions();
      this.sortDeliveryGrid();
      this.applyDefaultPackageSelection();
      this.syncGiftUI();
      this.syncPurchaseTypeUI();
      this.updatePackagePrices();
      this.syncSellingPlanForVariant();
      this.updateUpsellPrices();
      this.syncClaimAtc();

      if (this.dataset.hideOneTime === 'true') {
        const subscription = this.querySelector('[data-purchase-type="subscription"]');
        const oneTime = this.querySelector('[data-purchase-type="one_time"]');
        if (oneTime) {
          oneTime.checked = false;
          oneTime.disabled = true;
        }
        if (subscription) {
          subscription.disabled = false;
          subscription.checked = true;
        }
        this.syncPurchaseTypeUI();
        this.syncClaimAtc();
      }
    }

    disconnectedCallback() {
      const form = document.getElementById('product-form-' + this.sectionId);
      if (form && this.onGiftFormSubmit) {
        form.removeEventListener('submit', this.onGiftFormSubmit, true);
      }
      if (form && this.onClaimFormSubmit) {
        form.removeEventListener('submit', this.onClaimFormSubmit, true);
      }
      if (this.onClaimProductAdded) {
        document.removeEventListener('theme:product:added', this.onClaimProductAdded);
      }
      document.removeEventListener('keydown', this.onGiftEscape);
      if (this.onCartDrawerOpen) {
        document.removeEventListener('theme:cart-drawer:open', this.onCartDrawerOpen);
      }
      document.body.classList.remove('js-gift-drawer-open');
      if (this.giftDrawer && this.giftDrawer.parentElement === document.body) {
        this.giftDrawer.remove();
      }
    }

    initRoutineUpsell() {
      const self = this;
      this.upsellRoot = this.querySelector('[data-routine-upsell]');
      this.upsellSelected = false;
      this.upsellVariant = null;
      this.upsellAdding = false;

      if (!this.upsellRoot) return;

      const variantScript = this.upsellRoot.querySelector('[data-upsell-variant]');
      if (variantScript) {
        try {
          this.upsellVariant = JSON.parse(variantScript.textContent);
        } catch (error) {
          this.upsellVariant = null;
        }
      }

      const toggle = this.upsellRoot.querySelector('[data-upsell-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          self.setUpsellSelected(!self.upsellSelected);
        });
      }

      document.addEventListener('theme:product:added', function () {
        self.addUpsellToCart();
      });

      document.addEventListener('theme:cart:add', function () {
        self.ensureValidPackageSelection();
        self.syncVariantIdToForm();
        self.syncSellingPlanForVariant();
      }, true);
    }

    setUpsellSelected(selected) {
      this.upsellSelected = Boolean(selected);
      if (!this.upsellRoot) return;

      this.ensureValidPackageSelection();
      this.syncVariantIdToForm();
      this.syncSellingPlanForVariant();

      const card = this.upsellRoot.querySelector('[data-upsell-card]');
      const toggle = this.upsellRoot.querySelector('[data-upsell-toggle]');
      const input = this.upsellRoot.querySelector('[data-upsell-variant-input]');

      if (card) {
        card.classList.toggle('is-selected', this.upsellSelected);
      }

      if (toggle) {
        toggle.setAttribute('aria-pressed', this.upsellSelected ? 'true' : 'false');
        toggle.textContent = this.upsellSelected
          ? (toggle.dataset.labelAdded || 'ADDED')
          : (toggle.dataset.labelAdd || 'ADD');
      }

      if (input) {
        input.value = this.upsellSelected && this.upsellVariant ? String(this.upsellVariant.id) : '';
      }
    }

    syncUpsellVisibility() {
      if (!this.upsellRoot) return;

      const subscriptionOnly = this.upsellRoot.dataset.subscriptionOnly === 'true';
      const hide = subscriptionOnly && !this.isSubscription();
      this.upsellRoot.classList.toggle('is-hidden', hide);

      if (hide && this.upsellSelected) {
        this.setUpsellSelected(false);
      }
    }

    getUpsellAllocation(planId) {
      if (!this.upsellVariant || !this.upsellVariant.selling_plan_allocations) return null;

      const allocations = this.upsellVariant.selling_plan_allocations;
      if (planId) {
        const match = allocations.find(function (allocation) {
          return String(allocation.selling_plan_id) === String(planId);
        });
        if (match) return match;
      }

      return allocations[0] || null;
    }

    updateUpsellPrices() {
      if (!this.upsellRoot || !this.upsellVariant) return;

      let price = this.upsellVariant.price;
      let compareAt = this.upsellVariant.compare_at_price;

      if (this.isSubscription()) {
        const allocation = this.getUpsellAllocation(this.getSelectedDeliveryPlanId());
        if (allocation) {
          price = allocation.price;
          compareAt = allocation.compare_at_price || this.upsellVariant.price;
        }
      }

      const priceEl = this.upsellRoot.querySelector('[data-upsell-price]');
      const compareEl = this.upsellRoot.querySelector('[data-upsell-compare]');

      if (priceEl) {
        priceEl.textContent = '+' + formatMoney(price, this.moneyFormat);
      }

      if (compareEl) {
        if (compareAt && compareAt > price) {
          compareEl.textContent = '+' + formatMoney(compareAt, this.moneyFormat);
          compareEl.classList.remove('is-hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('is-hidden');
        }
      }
    }

    addUpsellToCart() {
      const self = this;
      if (this.upsellAdding || !this.upsellSelected || !this.upsellVariant) return;

      this.upsellAdding = true;
      const formData = new FormData();
      formData.append('id', String(this.upsellVariant.id));
      formData.append('quantity', '1');

      if (this.isSubscription()) {
        const planId = this.getSelectedDeliveryPlanId();
        const allocation = this.getUpsellAllocation(planId);
        // Only attach a recurring allocation; never fall back to a fixed Juo plan.
        if (allocation && allocation.selling_plan_id && this.upsellVariant.selling_plan_allocations.some(function (entry) {
          return String(entry.selling_plan_id) === String(allocation.selling_plan_id);
        })) {
          formData.append('selling_plan', String(allocation.selling_plan_id));
        }
      }

      const cartAddUrl = this.upsellRoot.dataset.cartAddUrl || '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (!data.status) {
            document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
          }
          self.upsellAdding = false;
          self.setUpsellSelected(false);
        })
        .catch(function () {
          self.upsellAdding = false;
        });
    }

    applyDefaultPackageSelection() {
      if (new URLSearchParams(window.location.search).has('variant')) return;

      this.refreshPackageItems();
      const defaultItem = this.querySelector('[data-default-package="true"]');
      if (!defaultItem) return;

      if (this.isSubscription() && defaultItem.dataset.availableForSubscription !== 'true') {
        return;
      }

      const input = defaultItem.querySelector('[data-package-input]');
      if (!input || input.disabled) return;

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    getActiveVariantSelects() {
      const all = Array.from(this.querySelectorAll('variant-selects'));
      const visible = all.find(function (el) {
        return el.style.display !== 'none';
      });

      return visible || all[0] || null;
    }

    refreshPackageItems() {
      this.variantSelects = this.getActiveVariantSelects();
      const grid = this.variantSelects
        ? this.variantSelects.querySelector('[data-package-grid]')
        : this.querySelector('[data-package-grid]');

      this.packageItems = grid
        ? grid.querySelectorAll(':scope > [data-package-value]')
        : [];

      this.updatePackageGridLayout();
    }

    updatePackageGridLayout() {
      this.variantSelects = this.getActiveVariantSelects();
      const grid = this.variantSelects
        ? this.variantSelects.querySelector('[data-package-grid]')
        : this.querySelector('[data-package-grid]');

      if (!grid) return;

      const isSubscription = this.isSubscription();
      const filterPackages = isSubscription || this.isGiftMode() || Boolean(this.getLockPackage());
      const seen = {};
      let visibleCount = 0;
      const self = this;

      grid.querySelectorAll(':scope > [data-package-value]').forEach(function (item) {
        const value = item.dataset.packageValue || '';
        if (seen[value]) return;
        if (!self.packageMatchesLock(item)) return;
        if (filterPackages && self.getLockPackage() === '' && item.dataset.availableForSubscription !== 'true') return;
        if (item.classList.contains('is-hidden')) return;
        if (item.style.display === 'none') return;

        seen[value] = true;
        visibleCount += 1;
      });

      grid.dataset.packageCount = String(visibleCount);
    }

    scheduleAfterVariantSwap(callback) {
      callback();
      requestAnimationFrame(function () {
        callback();
      });
      // product-info keeps the previous variant-selects in the DOM for 500ms
      clearTimeout(this.variantSwapTimer);
      this.variantSwapTimer = setTimeout(callback, 550);
    }

    getSellingPlanInput() {
      const formId = 'product-form-' + this.sectionId;
      const form = document.getElementById(formId);
      if (form) {
        const input = form.querySelector('[name="selling_plan"], [data-selling-plan-input]');
        if (input) return input;
      }

      return document.querySelector('#' + formId + ' [name="selling_plan"], form[data-product-form] [name="selling_plan"], [data-selling-plan-input]');
    }

    setSellingPlanValue(planId) {
      if (!this.sellingPlanInput) {
        this.sellingPlanInput = this.getSellingPlanInput();
      }

      if (!this.sellingPlanInput) return;

      const nextValue = planId ? String(planId) : '';
      this.sellingPlanInput.value = nextValue;
      this.sellingPlanInput.disabled = !nextValue;
    }

    resolveRecurringPlanId(planId, variantId) {
      const plans = (this.sellingPlansMap[String(variantId)] || []).filter(isJuoRecurringPlan);
      if (!plans.length) return '';

      if (planId && plans.some(function (plan) {
        return String(plan.id) === String(planId);
      })) {
        return String(planId);
      }

      return String(plans[0].id);
    }

    parseData() {
      this.variantSelects = this.getActiveVariantSelects();
      const scope = this.variantSelects || this;
      const variantsScript = scope.querySelector('[data-product-variants]');
      const plansScript = scope.querySelector('[data-variant-selling-plans]');

      if (variantsScript) {
        try {
          this.variants = JSON.parse(variantsScript.textContent);
        } catch (error) {
          this.variants = [];
        }
      }

      if (plansScript) {
        try {
          const parsed = JSON.parse(plansScript.textContent);
          const cleaned = {};
          Object.keys(parsed || {}).forEach(function (variantId) {
            cleaned[variantId] = (parsed[variantId] || []).filter(isJuoRecurringPlan);
          });
          this.sellingPlansMap = cleaned;
        } catch (error) {
          this.sellingPlansMap = {};
        }
      }
    }

    bindEvents() {
      const self = this;

      this.purchaseTypeInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          self.syncPurchaseTypeUI();
          self.updatePackagePrices();
          self.syncSellingPlanForVariant();
        });
      });

      this.querySelectorAll('[data-gift-intent]').forEach(function (input) {
        input.addEventListener('change', function () {
          if (self.navigateGiftCompanionIfNeeded(input.value)) return;
          self.syncGiftUI();
          self.syncPurchaseTypeUI();
          self.updatePackagePrices();
          self.syncSellingPlanForVariant();
        });
      });

      this.deliveryInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          self.updateDeliverySelection();
        });
      });

      this.addEventListener('change', function (event) {
        if (!event.target) return;

        if (event.target.matches('[data-package-input], [data-size-input]')) {
          self.scheduleAfterVariantSwap(function () {
            self.refreshPackageItems();
            self.syncGiftUI();
            self.syncPurchaseTypeUI();
            self.updateCardStates();
            self.updatePackagePrices();
            self.syncSellingPlanForVariant();
          });
        }

        if (event.target.matches('[data-gift-length]')) {
          const monthsFromInput = parseInt(event.target.dataset.giftMonths, 10)
            || parseGiftMonths(event.target.value)
            || 0;
          self.syncGiftLengthProperty();
          self.syncVariantIdToForm();
          self.updatePackagePrices(monthsFromInput);
          self.scheduleAfterVariantSwap(function () {
            self.syncGiftQuantity();
            self.syncVariantIdToForm();
            self.updateCardStates();
            self.updatePackagePrices(monthsFromInput);
            self.syncSellingPlanForVariant();
          });
        }
      });

      this.addEventListener('click', function (event) {
        const label = event.target.closest('label[for]');
        if (!label || !self.contains(label)) return;

        self.scheduleAfterVariantSwap(function () {
          self.refreshPackageItems();
          self.syncGiftUI();
          self.syncPurchaseTypeUI();
          self.updateCardStates();
          self.updatePackagePrices();
          self.syncSellingPlanForVariant();
        });
      });

      this.querySelectorAll('[data-subscription-info-toggle]').forEach(function (button) {
        const wrap = button.closest('.product-information__info-wrap');

        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (!wrap) return;
          wrap.classList.toggle('is-open');
        });

        button.addEventListener('mousedown', function (event) {
          event.preventDefault();
          event.stopPropagation();
        });
      });

      document.addEventListener('click', function (event) {
        if (event.target.closest('[data-subscription-info-toggle]')) return;

        self.querySelectorAll('.product-information__info-wrap.is-open').forEach(function (wrap) {
          wrap.classList.remove('is-open');
        });
      });

      if (typeof subscribe !== 'undefined' && window.theme && window.theme.PUB_SUB_EVENTS) {
        subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function () {
          self.scheduleAfterVariantSwap(function () {
            self.refreshPackageItems();
            self.parseData();
            self.syncGiftUI();
            self.syncPurchaseTypeUI();
            self.updateCardStates();
            self.updatePackagePrices();
            self.syncSellingPlanForVariant();
          });
        });

        subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, function () {
          self.scheduleAfterVariantSwap(function () {
            self.refreshPackageItems();
            self.syncGiftUI();
            self.syncPurchaseTypeUI();
          });
        });
      }
    }

    getPurchaseType() {
      const checked = this.querySelector('[data-purchase-type]:checked');
      return checked ? checked.value : this.defaultPurchaseType;
    }

    isSubscription() {
      if (this.dataset.hideOneTime === 'true') return this.hasSubscriptions;
      if (this.isGiftMode()) return false;
      return this.hasSubscriptions && this.getPurchaseType() === 'subscription';
    }

    getLockPackage() {
      return String(this.dataset.lockPackage || '').trim().toLowerCase();
    }

    isClaimGiftMode() {
      return this.dataset.claimGiftMode === 'true';
    }

    getLockDeliveryWeeks() {
      const weeks = parseInt(this.dataset.lockDeliveryWeeks, 10);
      return weeks > 0 ? weeks : 0;
    }

    packageMatchesLock(item) {
      const lockPackage = this.getLockPackage();
      if (!lockPackage) return true;
      if (item.dataset.lockPackageMatch === 'false') return false;
      if (item.dataset.lockPackageMatch === 'true') return true;
      const haystack = [
        item.dataset.packageValue || '',
        (item.querySelector('.product-information__title-lg') || {}).textContent || '',
      ].join(' ').toLowerCase();
      return haystack.indexOf(lockPackage) !== -1;
    }

    initClaimGift() {
      if (!this.isClaimGiftMode() && this.dataset.showDiscountCode !== 'true') return;

      const form = document.getElementById('product-form-' + this.sectionId);
      if (!form) return;

      this.onClaimFormSubmit = this.onClaimFormSubmit.bind(this);
      this.onClaimProductAdded = this.onClaimProductAdded.bind(this);
      form.addEventListener('submit', this.onClaimFormSubmit, true);
      document.addEventListener('theme:product:added', this.onClaimProductAdded);

      this.lockClaimGiftLengthFromUrl();
    }

    syncClaimAtc() {
      if (!this.isClaimGiftMode()) return;
      this.syncBuyButtonAvailability();
    }

    getClaimGiftMonthsFromUrl() {
      let params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (error) {
        return 0;
      }

      const raw = params.get('gift_length')
        || params.get('months')
        || params.get('length')
        || '';
      const months = parseGiftMonths(raw);
      if (months === 2 || months === 3 || months === 6 || months === 12) return months;
      return 0;
    }

    getClaimGiftMonths() {
      const fromData = parseInt(this.dataset.claimGiftMonths, 10);
      if (fromData === 2 || fromData === 3 || fromData === 6 || fromData === 12) return fromData;
      return this.getClaimGiftMonthsFromUrl();
    }

    lockClaimGiftLengthFromUrl() {
      if (!this.isClaimGiftMode()) return;

      const months = this.getClaimGiftMonthsFromUrl() || this.getClaimGiftMonths();
      const display = this.querySelector('[data-claim-length-display]');

      if (!months) {
        return;
      }

      this.dataset.claimGiftMonths = String(months);

      if (display) {
        display.textContent = months + ' months';
      }

      const items = this.querySelectorAll('[data-claim-length-item]');
      let matchedInput = null;

      items.forEach(function (item) {
        const itemMonths = parseInt(item.dataset.giftMonths, 10);
        const input = item.querySelector('[data-gift-length]');
        const isMatch = itemMonths === months;
        item.classList.toggle('is-locked-out', !isMatch);
        item.classList.remove('is-hidden');
        if (input) {
          input.checked = isMatch;
          if (isMatch) matchedInput = input;
        }
      });

      if (matchedInput) {
        matchedInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (display) {
          display.textContent = matchedInput.dataset.giftLengthLabel || (String(months) + ' months');
        }
      } else if (display) {
        display.textContent = String(months) + ' months';
      }

      this.syncSellingPlanForVariant();
      this.syncClaimAtc();
      this.syncBuyButtonAvailability();
    }

    findClaimSellingPlanId(variantId, months) {
      const self = this;
      const plans = (this.sellingPlansMap[String(variantId)] || []).filter(isJuoRecurringPlan);
      if (!plans.length) return '';

      function planText(plan) {
        return String((plan && plan.group_name) || '') + ' ' + String((plan && plan.name) || '');
      }

      function planCycles(plan) {
        const fromField = parseInt(plan && plan.cycles, 10);
        if (fromField > 0) return fromField;
        const match = planText(plan).match(/(\d+)\s*cycles?/i);
        return match ? parseInt(match[1], 10) : 0;
      }

      function pickClaimPlan(matches) {
        if (!matches.length) return null;

        const selectedInput = self.querySelector('[data-delivery-input]:checked');
        const weeks = self.getDeliveryWeeks(selectedInput) || self.getRecommendedWeeks();
        if (weeks) {
          const byWeeks = matches.filter(function (plan) {
            return parseWeeksFromPlanName(plan.name) === weeks;
          });
          if (byWeeks.length) return byWeeks[0];
        }

        return matches[0];
      }

      if (months > 0) {
        const byCycles = plans.filter(function (plan) {
          return planCycles(plan) === months;
        });
        const matched = pickClaimPlan(byCycles);
        if (matched) return String(matched.id);

        const byName = plans.filter(function (plan) {
          const text = planText(plan).toLowerCase();
          return text.indexOf(String(months)) !== -1
            && (text.indexOf('month') !== -1 || text.indexOf('maand') !== -1 || text.indexOf('gift') !== -1 || text.indexOf('cycle') !== -1);
        });
        const named = pickClaimPlan(byName);
        if (named) return String(named.id);
      }

      const fallback = pickClaimPlan(plans);
      return fallback ? String(fallback.id) : '';
    }

    getClaimDiscountInput() {
      return this.querySelector('[data-claim-discount-input]');
    }

    getClaimDiscountCode() {
      const input = this.getClaimDiscountInput();
      return input ? String(input.value || '').trim() : '';
    }

    setClaimDiscountError(message) {
      const errorEl = this.querySelector('[data-claim-discount-error]');
      if (!errorEl) return;
      if (message) {
        errorEl.textContent = message;
        errorEl.classList.remove('is-hidden');
      } else {
        errorEl.textContent = '';
        errorEl.classList.add('is-hidden');
      }
    }

    applyClaimDiscount(code) {
      let updateUrl = (window.theme && window.theme.routes && window.theme.routes.cart_update_url)
        || '/cart/update.js';
      if (updateUrl.indexOf('.js') === -1) {
        updateUrl = updateUrl.replace(/\/?$/, '') + '.js';
      }

      return fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ discount: code }),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('discount_failed');
          }
          return response.text();
        })
        .then(function (text) {
          let data;
          try {
            data = JSON.parse(text);
          } catch (error) {
            throw new Error('discount_failed');
          }
          const codes = data && Array.isArray(data.discount_codes) ? data.discount_codes : [];
          const applied = codes.some(function (entry) {
            return String(entry.code || '').toUpperCase() === String(code).toUpperCase() && entry.applicable;
          });
          if (!applied) {
            const err = new Error('discount_not_applicable');
            err.code = 'discount_not_applicable';
            throw err;
          }
          return data;
        });
    }

    onClaimFormSubmit(event) {
      const needsDiscount = this.dataset.showDiscountCode === 'true';
      if (!needsDiscount && !this.isClaimGiftMode()) return;

      const code = this.getClaimDiscountCode();
      this.setClaimDiscountError('');

      if (this.isClaimGiftMode() && !this.getClaimGiftMonths()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (needsDiscount && !code) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.setClaimDiscountError(
          (window.theme && window.theme.strings && window.theme.strings.discount_code_required)
            || 'Enter your gift code'
        );
        const input = this.getClaimDiscountInput();
        if (input) input.focus();
        this._pendingClaimDiscount = '';
        return;
      }

      // Apply after the subscription is in the cart — empty carts reject most codes.
      this._pendingClaimDiscount = code || '';
    }

    onClaimProductAdded() {
      const code = this._pendingClaimDiscount;
      if (!code) return;

      this._pendingClaimDiscount = '';
      const self = this;

      this.applyClaimDiscount(code)
        .then(function () {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        })
        .catch(function () {
          self.setClaimDiscountError(
            (window.theme && window.theme.strings && window.theme.strings.discount_not_applicable)
              || 'Discount code is not applicable'
          );
        });
    }

    lockDeliveryOptions() {
      const locked = this.getLockDeliveryWeeks();
      if (!locked) return;

      const self = this;
      this.querySelectorAll('.product-information__delivery-item').forEach(function (item) {
        const weeks = parseInt(item.dataset.deliveryWeeks, 10) || self.getDeliveryWeeks(item.querySelector('[data-delivery-input]'));
        const input = item.querySelector('[data-delivery-input]');
        if (weeks !== locked) {
          item.classList.add('is-hidden');
          if (input) {
            input.checked = false;
            input.disabled = true;
          }
          return;
        }

        item.classList.remove('is-hidden');
        if (input) {
          input.disabled = false;
          input.checked = true;
        }
      });
    }

    isGiftProduct() {
      return this.dataset.giftProduct === 'true';
    }

    isGiftMode() {
      if (this.isGiftProduct()) return true;
      const checked = this.querySelector('[data-gift-intent]:checked');
      return Boolean(checked && checked.value === 'gift');
    }

    navigateGiftCompanionIfNeeded(intent) {
      const goingToGift = intent === 'gift';
      if (goingToGift === this.isGiftProduct()) return false;

      let map = {};
      const mapScript = this.querySelector('[data-gift-companion-urls]');
      if (mapScript) {
        try {
          map = JSON.parse(mapScript.textContent) || {};
        } catch (error) {
          map = {};
        }
      }

      const fallback = goingToGift ? this.dataset.giftGiftUrl : this.dataset.giftSelfUrl;
      if (!fallback && Object.keys(map).length === 0) return false;

      const packageInput = this.querySelector('[data-package-input]:checked');
      const packageItem = packageInput && packageInput.closest('[data-package-value]');
      const packageValue = (packageItem && packageItem.dataset.packageValue) || '';
      const url = map[packageValue] || fallback;
      if (!url) return false;

      window.location.assign(url);
      return true;
    }

    getQuantityInput() {
      const form = document.getElementById('product-form-' + this.sectionId);
      return form && form.querySelector('[name="quantity"]');
    }

    getSelectedGiftMonths() {
      const lengthInput = this.querySelector('[data-gift-length]:checked');
      if (!lengthInput) return 0;
      return parseInt(lengthInput.dataset.giftMonths, 10) || parseGiftMonths(lengthInput.value) || 0;
    }

    getGiftDeliveryCount() {
      const months = this.getSelectedGiftMonths();
      const weeks = this.getRecommendedWeeks() || 2;
      if (!months) return 0;
      return Math.max(1, Math.round((months * 4) / weeks));
    }

    syncGiftLengthProperty() {
      const lengthInput = this.querySelector('[data-gift-length]:checked');
      const propertyInput = this.querySelector('[data-gift-length-property]');
      if (!lengthInput || !propertyInput) return;
      // Always store English for API/checkout; UI labels stay localized via data-gift-length-label.
      propertyInput.value =
        lengthInput.dataset.giftLengthEn
        || (lengthInput.dataset.giftMonths ? lengthInput.dataset.giftMonths + ' months' : '')
        || lengthInput.value
        || '';
    }

    getGiftPackagePricing(packageValue, monthsOverride) {
      const selectedMonths = parseInt(monthsOverride, 10) || this.getSelectedGiftMonths();
      const packageItem = Array.from(this.packageItems || []).find(function (item) {
        return item.dataset.packageValue === packageValue;
      }) || this.querySelector('[data-package-grid] [data-package-value="' + String(packageValue || '').replace(/"/g, '\\"') + '"]');

      if (packageItem && selectedMonths) {
        const rawPrices = packageItem.getAttribute('data-gift-length-prices')
          || packageItem.dataset.giftLengthPrices
          || '';
        if (rawPrices) {
          try {
            const priceMap = JSON.parse(rawPrices);
            const entry = priceMap[String(selectedMonths)] || priceMap[selectedMonths];
            if (entry && entry.price != null) {
              return {
                price: Number(entry.price),
                compareAt: Number(entry.compare_at || 0),
                variant: null
              };
            }
          } catch (error) {
            // Fall through to variant lookup.
          }
        }
      }

      const packageFieldset = this.querySelector('[data-package-fieldset]');
      const packagePosition = parseInt((packageFieldset || {}).dataset.optionPosition, 10) || 1;
      const lengthFieldset = this.querySelector('[data-gift-length-fieldset]');
      const lengthPosition = parseInt((lengthFieldset || {}).dataset.optionPosition, 10) || 0;

      const matches = (this.variants || []).filter(function (variant) {
        if (variant['option' + packagePosition] !== packageValue) return false;
        if (lengthPosition && selectedMonths) {
          return parseGiftMonths(variant['option' + lengthPosition]) === selectedMonths;
        }
        return true;
      });
      if (!matches.length) return null;

      const variant = matches.find(function (entry) {
        return entry.available !== false;
      }) || matches[0];

      return {
        price: variant.price,
        compareAt: variant.compare_at_price || 0,
        variant: variant
      };
    }

    getMonthlyPackagePricing(packageValue) {
      return this.getGiftPackagePricing(packageValue);
    }

    syncGiftQuantity() {
      const input = this.getQuantityInput();
      if (!input) return;
      input.value = '1';
    }

    initGiftDate() {
      const input = this.querySelector('[data-gift-date]');
      if (!input) return;

      const today = new Date();
      const minDate = new Date(today);
      minDate.setDate(minDate.getDate() + 1);

      const max = new Date(today);
      max.setMonth(max.getMonth() + 9);

      const minValue = this.formatDateInputValue(minDate);
      input.min = minValue;
      input.max = this.formatDateInputValue(max);
      if (!input.value || input.value < minValue) {
        input.value = minValue;
      }

      const wrap = input.closest('.product-information__gift-date-wrap');
      if (wrap) {
        wrap.addEventListener('click', function () {
          if (input.disabled) return;
          if (typeof input.showPicker === 'function') {
            try {
              input.showPicker();
            } catch (error) {
              input.focus();
            }
          }
        });
      }
    }

    formatDateInputValue(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    }

    syncGiftUI() {
      const isGift = this.isGiftMode();
      this.setAttribute('data-gift-mode', isGift ? 'gift' : 'self');

      const helper = this.querySelector('[data-gift-helper]');
      const infoHelper = this.querySelector('[data-subscription-info-helper]');
      const panel = this.querySelector('[data-gift-panel]');
      if (helper) helper.classList.toggle('is-hidden', !isGift);
      if (infoHelper) infoHelper.classList.toggle('is-hidden', isGift);
      if (panel) panel.classList.toggle('is-hidden', !isGift);

      const oneTime = this.querySelector('[data-purchase-type="one_time"]');
      const subscription = this.querySelector('[data-purchase-type="subscription"]');
      const oneTimeLabel = oneTime ? this.querySelector('label[for="' + oneTime.id + '"]') : null;
      const subscriptionLabel = subscription ? this.querySelector('label[for="' + subscription.id + '"]') : null;

      if (isGift) {
        if (oneTime) {
          oneTime.checked = false;
          oneTime.disabled = true;
        }
        if (oneTimeLabel) {
          oneTimeLabel.classList.add('product-information__card--gift-disabled');
          oneTimeLabel.classList.remove('product-information__card--selected');
        }
        if (subscription) {
          subscription.disabled = false;
          subscription.checked = true;
        }
        if (subscriptionLabel) {
          subscriptionLabel.classList.remove('product-information__card--gift-disabled');
          subscriptionLabel.classList.add('product-information__card--selected');
        }
      } else {
        if (subscription) subscription.disabled = false;
        if (subscriptionLabel) {
          subscriptionLabel.classList.remove('product-information__card--gift-disabled');
        }
        if (oneTime) oneTime.disabled = false;
        if (oneTimeLabel) {
          oneTimeLabel.classList.remove('product-information__card--gift-disabled');
        }
      }

      this.querySelectorAll('[data-gift-property], [data-gift-length], [data-gift-date]').forEach(function (el) {
        el.disabled = !isGift;
      });

      this.sizeFieldset = this.querySelector('[data-size-fieldset]');
      if (this.sizeFieldset) {
        this.sizeFieldset.classList.toggle('is-hidden', isGift);
      }

      if (this.giftDrawer) {
        this.giftDrawer.querySelectorAll('[data-gift-detail]').forEach(function (el) {
          el.disabled = !isGift;
        });
        if (!isGift) this.closeGiftDrawer();
      }

      this.syncGiftQuantity();
      this.syncGiftLengthProperty();
      this.syncGiftAtc();
      this.syncGiftFrequencyNote();
      this.ensureValidPackageSelection();
      this.updatePackageGridLayout();

      const selfBenefits = this.querySelector('[data-subscription-benefits-self]');
      const giftBenefits = this.querySelector('[data-subscription-benefits-gift]');
      if (selfBenefits) selfBenefits.hidden = isGift;
      if (giftBenefits) giftBenefits.hidden = !isGift;
    }

    syncGiftAtc() {
      if (this.dataset.showGiftToggle !== 'true') return;

      const button = document.getElementById('ProductSubmitButton-' + this.sectionId);
      if (!button) return;

      const textEl = button.querySelector('[data-add-to-cart-text]');
      if (!textEl) return;

      if (!this.defaultAtcText) {
        this.defaultAtcText = textEl.textContent.trim();
      }

      const isGift = this.isGiftMode();
      const giftLabel = this.dataset.giftAtcLabel || this.defaultAtcText;
      const current = textEl.textContent.trim();
      const canSwap = current === this.defaultAtcText || current === giftLabel;

      button.classList.toggle('is-gift-cta', isGift);

      let icon = button.querySelector('[data-gift-atc-icon]');
      if (isGift && !icon && this.dataset.giftIconUrl) {
        icon = document.createElement('img');
        icon.setAttribute('data-gift-atc-icon', '');
        icon.src = this.dataset.giftIconUrl;
        icon.alt = '';
        icon.width = 24;
        icon.height = 24;
        button.insertBefore(icon, textEl);
      }

      if (canSwap) {
        textEl.textContent = isGift ? giftLabel : this.defaultAtcText;
      }
    }

    initGiftDrawer() {
      this.giftDrawer = this.querySelector('[data-gift-drawer]');
      if (!this.giftDrawer) return;

      this.giftDrawerIsOpen = false;
      this.giftDrawerStep = 'details';
      const self = this;
      this.onGiftFormSubmit = this.onGiftFormSubmit.bind(this);
      this.onGiftEscape = this.onGiftEscape.bind(this);

      if (this.giftDrawer.parentElement !== document.body) {
        document.body.appendChild(this.giftDrawer);
      }

      const form = document.getElementById('product-form-' + this.sectionId);
      if (form) {
        form.addEventListener('submit', this.onGiftFormSubmit, true);
      }

      this.giftDrawer.querySelectorAll('[data-gift-drawer-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.closeGiftDrawer();
        });
      });

      this.bindGiftFieldGuards();

      const reviewButton = this.giftDrawer.querySelector('[data-gift-review]');
      if (reviewButton) {
        reviewButton.addEventListener('click', function () {
          if (!self.validateGiftDetails()) return;
          self.showGiftReview();
        });
      }

      const editButton = this.giftDrawer.querySelector('[data-gift-edit]');
      if (editButton) {
        editButton.addEventListener('click', function () {
          self.showGiftDetails();
        });
      }

      this.onCartDrawerOpen = function () {
        self.closeGiftDrawer();
      };
      document.addEventListener('theme:cart-drawer:open', this.onCartDrawerOpen);
    }

    onGiftFormSubmit(event) {
      if (!this.isGiftMode()) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (this.giftDrawerStep === 'review') {
        if (!this.validateGiftDetails()) return;
        this.submitGiftCheckout(event.submitter || this.giftDrawer.querySelector('[data-gift-checkout]'));
        return;
      }

      if (!this.giftDrawerIsOpen) {
        this.openGiftDrawer();
        return;
      }

      if (this.validateGiftDetails()) this.showGiftReview();
    }

    submitGiftCheckout(button) {
      if (this.giftCheckoutSubmitting) return;

      const form = document.getElementById('product-form-' + this.sectionId);
      if (!form) return;

      this.syncVariantIdToForm();
      this.syncGiftQuantity();
      this.syncGiftLengthProperty();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const formData = new FormData(form);
      if (!formData.get('selling_plan')) formData.delete('selling_plan');

      this.giftCheckoutSubmitting = true;
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }

      const self = this;
      const cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
      const root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
      const checkoutUrl = root.replace(/\/?$/, '/') + 'checkout';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status) {
            throw data;
          }
          var ensureGift = window.themeFreeGiftEnsure
            ? window.themeFreeGiftEnsure()
            : Promise.resolve();
          return Promise.resolve(ensureGift).then(function () {
            window.location.href = checkoutUrl;
          });
        })
        .catch(function () {
          self.giftCheckoutSubmitting = false;
          if (button) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        });
    }

    onGiftEscape(event) {
      if (event.key === 'Escape') this.closeGiftDrawer();
    }

    openGiftDrawer() {
      if (!this.giftDrawer) return;

      this.giftDrawerIsOpen = true;
      this.giftDrawer.hidden = false;
      this.giftDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('js-gift-drawer-open');
      document.addEventListener('keydown', this.onGiftEscape);

      const self = this;
      requestAnimationFrame(function () {
        self.giftDrawer.classList.add('is-open');
      });

      this.giftDrawer.querySelectorAll('[data-gift-detail]').forEach(function (el) {
        el.disabled = false;
      });

      this.showGiftDetails();
    }

    closeGiftDrawer() {
      if (!this.giftDrawer || !this.giftDrawerIsOpen) return;

      this.giftDrawerIsOpen = false;
      this.giftDrawerStep = 'details';
      this.giftDrawer.classList.remove('is-open');
      this.giftDrawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('js-gift-drawer-open');
      document.removeEventListener('keydown', this.onGiftEscape);

      const self = this;
      window.setTimeout(function () {
        if (!self.giftDrawer.classList.contains('is-open')) {
          self.giftDrawer.hidden = true;
          self.showGiftDetails(false);
        }
      }, 300);
    }

    giftFieldValue(name) {
      const field = this.giftDrawer && this.giftDrawer.querySelector('[data-gift-field="' + name + '"]');
      if (!field) return '';
      return String(field.value || '').trim();
    }

    setGiftReviewText(selector, value) {
      const el = this.giftDrawer.querySelector(selector);
      if (!el) return;
      el.textContent = value || '';
    }

    formatGiftReviewDate(value) {
      if (!value) return '';
      const parts = String(value).split('-');
      if (parts.length !== 3) return value;
      return parts[2] + '/' + parts[1] + '/' + parts[0];
    }

    showGiftDetails(focusFirst) {
      this.giftDrawerStep = 'details';
      const details = this.giftDrawer.querySelector('[data-gift-view="details"]');
      const review = this.giftDrawer.querySelector('[data-gift-view="review"]');
      const titleDetails = this.giftDrawer.querySelector('[data-gift-title-details]');
      const titleReview = this.giftDrawer.querySelector('[data-gift-title-review]');

      if (details) details.hidden = false;
      if (review) review.hidden = true;
      if (titleDetails) titleDetails.hidden = false;
      if (titleReview) titleReview.hidden = true;

      this.giftDrawer.querySelectorAll('[data-gift-detail]').forEach(function (el) {
        el.disabled = false;
      });

      const panel = this.giftDrawer.querySelector('.gift-details-drawer__panel');
      if (panel) panel.scrollTop = 0;

      if (focusFirst === false) return;
      const first = this.giftDrawer.querySelector('[data-gift-detail]');
      if (first) first.focus();
    }

    showGiftReview() {
      this.populateGiftReview();
      this.giftDrawerStep = 'review';

      const details = this.giftDrawer.querySelector('[data-gift-view="details"]');
      const review = this.giftDrawer.querySelector('[data-gift-view="review"]');
      const titleDetails = this.giftDrawer.querySelector('[data-gift-title-details]');
      const titleReview = this.giftDrawer.querySelector('[data-gift-title-review]');

      if (details) details.hidden = true;
      if (review) review.hidden = false;
      if (titleDetails) titleDetails.hidden = true;
      if (titleReview) titleReview.hidden = false;

      const panel = this.giftDrawer.querySelector('.gift-details-drawer__panel');
      const title = this.giftDrawer.querySelector('.gift-details-drawer__title');
      if (title) title.focus({ preventScroll: true });
      if (panel) {
        panel.scrollTop = 0;
        requestAnimationFrame(function () {
          panel.scrollTop = 0;
        });
      }
    }

    populateGiftReview() {
      const packageInput = this.querySelector('[data-package-input]:checked');
      const packageItem = packageInput && packageInput.closest('[data-package-value]');
      const packageTitle = packageItem && packageItem.querySelector('.product-information__title-md');
      this.setGiftReviewText('[data-gift-review-package]', packageTitle ? packageTitle.textContent.trim() : '');

      this.setGiftReviewText('[data-gift-review-frequency]', this.giftDrawer.dataset.giftFrequency || '');

      const months = this.getSelectedGiftMonths();
      const deliveries = this.getGiftDeliveryCount() || months;
      const lengthInput = this.querySelector('[data-gift-length]:checked');
      this.setGiftReviewText(
        '[data-gift-review-length]',
        (lengthInput && (lengthInput.dataset.giftLengthLabel || lengthInput.value)) || ''
      );

      const dateInput = this.querySelector('[data-gift-date]');
      this.setGiftReviewText('[data-gift-review-date]', this.formatGiftReviewDate(dateInput && dateInput.value));

      const variant = this.getCurrentVariant();
      let totalPrice = variant ? variant.price : 0;
      if (variant && this.isSubscription() && !this.isGiftMode() && !this.isClaimGiftMode()) {
        const planId = this.getSelectedDeliveryPlanId();
        const allocation = this.getAllocationForPlan(variant.id, planId)
          || (this.sellingPlansMap[String(variant.id)] || [])[0];
        if (allocation && allocation.price != null) totalPrice = allocation.price;
      }

      const unitPrice = deliveries > 1 ? Math.round(totalPrice / deliveries) : totalPrice;
      const formattedUnit = formatMoney(unitPrice, this.moneyFormat);
      const formattedTotal = formatMoney(totalPrice, this.moneyFormat);
      this.setGiftReviewText('[data-gift-review-total]', formattedTotal);

      const template = deliveries === 1
        ? this.giftDrawer.dataset.giftDeliveryOne
        : this.giftDrawer.dataset.giftDeliveryOther;
      const deliveriesEl = this.giftDrawer.querySelector('[data-gift-review-deliveries]');
      if (deliveriesEl) {
        deliveriesEl.textContent = String(template || '')
          .replace('__COUNT__', String(deliveries))
          .replace('__PRICE__', formattedUnit);
      }

      const firstName = this.giftFieldValue('first_name');
      const lastName = this.giftFieldValue('last_name');
      this.setGiftReviewText('[data-gift-review-recipient-name]', [firstName, lastName].filter(Boolean).join(' '));
      this.setGiftReviewText('[data-gift-review-email]', this.giftFieldValue('email'));
      this.setGiftReviewText('[data-gift-review-address]', this.giftFieldValue('address'));
      this.setGiftReviewText(
        '[data-gift-review-city]',
        [this.giftFieldValue('postal'), this.giftFieldValue('city')].filter(Boolean).join(' ')
      );

      const countryField = this.giftDrawer.querySelector('[data-gift-field="country"]');
      const countryText = countryField && countryField.options && countryField.selectedIndex >= 0
        ? countryField.options[countryField.selectedIndex].text
        : this.giftFieldValue('country');
      this.setGiftReviewText('[data-gift-review-country]', countryText);

      const phone = this.giftFieldValue('phone');
      const phoneEl = this.giftDrawer.querySelector('[data-gift-review-phone]');
      if (phoneEl) {
        phoneEl.hidden = !phone;
        phoneEl.textContent = phone;
      }

      const note = this.giftFieldValue('note');
      const noteEl = this.giftDrawer.querySelector('[data-gift-review-note]');
      if (noteEl) {
        noteEl.hidden = !note;
        noteEl.textContent = note ? '“' + note + '”' : '';
      }

      this.setGiftReviewText('[data-gift-review-sender]', this.giftFieldValue('sender'));
    }

    bindGiftFieldGuards() {
      const self = this;

      this.giftDrawer.querySelectorAll('[data-gift-detail]').forEach(function (input) {
        input.addEventListener('input', function () {
          self.constrainGiftField(input);
          self.clearGiftFieldError(input);
        });
      });
    }

    constrainGiftField(input) {
      const type = input.getAttribute('data-gift-validate');

      if (type === 'phone') {
        input.value = input.value.replace(/[^\d+\s()./-]/g, '');
        return;
      }

      if (type === 'email') {
        input.value = input.value.replace(/\s/g, '');
        return;
      }

      if (type === 'postal') {
        input.value = input.value.replace(/[^A-Za-z0-9\s]/g, '');
        return;
      }

      if (type === 'name' || type === 'city') {
        input.value = input.value.replace(/[\d@]/g, '');
      }
    }

    normalizeGiftField(input) {
      const type = input.getAttribute('data-gift-validate');

      if (type === 'email') {
        input.value = input.value.trim().toLowerCase();
        return;
      }

      if (type === 'postal' && this.isGiftCountryNetherlands()) {
        const compact = input.value.replace(/\s/g, '').toUpperCase();
        if (/^[1-9][0-9]{3}[A-Z]{2}$/.test(compact)) {
          input.value = compact.slice(0, 4) + ' ' + compact.slice(4);
        } else {
          input.value = input.value.trim().toUpperCase();
        }
      }
    }

    isGiftCountryNetherlands() {
      const field = this.giftDrawer && this.giftDrawer.querySelector('[data-gift-field="country"]');
      if (!field) return true;
      const value = String(field.value || '').toLowerCase();
      const selected = field.options && field.selectedIndex >= 0 ? field.options[field.selectedIndex] : null;
      const text = selected ? String(selected.text || '').toLowerCase() : '';
      return value === 'netherlands' || value === 'nl' || value === 'nederland'
        || text.indexOf('netherland') !== -1 || text.indexOf('nederland') !== -1;
    }

    giftErrorMessage(key) {
      const map = {
        required: this.giftDrawer.dataset.giftErrorRequired,
        name: this.giftDrawer.dataset.giftErrorName,
        email: this.giftDrawer.dataset.giftErrorEmail,
        address: this.giftDrawer.dataset.giftErrorAddress,
        postal: this.giftDrawer.dataset.giftErrorPostal,
        city: this.giftDrawer.dataset.giftErrorCity,
        phone: this.giftDrawer.dataset.giftErrorPhone
      };
      return map[key] || map.required || '';
    }

    setGiftFieldError(input, message) {
      input.classList.add('is-invalid');
      input.setAttribute('aria-invalid', 'true');
      const wrap = input.closest('.gift-details-drawer__control');
      const error = wrap && wrap.querySelector('[data-gift-error]');
      if (error) {
        error.textContent = message || '';
        error.hidden = !message;
      }
    }

    clearGiftFieldError(input) {
      input.classList.remove('is-invalid');
      input.removeAttribute('aria-invalid');
      const wrap = input.closest('.gift-details-drawer__control');
      const error = wrap && wrap.querySelector('[data-gift-error]');
      if (error) {
        error.textContent = '';
        error.hidden = true;
      }
    }

    validateGiftField(input) {
      if (!input) return true;
      if (input.disabled) {
        this.clearGiftFieldError(input);
        return true;
      }

      const type = input.getAttribute('data-gift-validate');
      const required = input.hasAttribute('data-gift-required');
      const value = String(input.value || '').trim();

      if (required && !value) {
        this.setGiftFieldError(input, this.giftErrorMessage('required'));
        return false;
      }

      if (!value) {
        this.clearGiftFieldError(input);
        return true;
      }

      let valid = true;
      let messageKey = type;

      if (type === 'name') valid = isGiftPersonName(value);
      else if (type === 'email') valid = isGiftEmail(value);
      else if (type === 'phone') valid = isGiftPhone(value);
      else if (type === 'city') valid = isGiftCity(value);
      else if (type === 'address') valid = isGiftAddress(value);
      else if (type === 'postal') valid = isGiftPostal(value, this.isGiftCountryNetherlands());
      else if (type === 'country') valid = Boolean(value);

      if (!valid) {
        this.setGiftFieldError(input, this.giftErrorMessage(messageKey || 'required'));
        return false;
      }

      this.clearGiftFieldError(input);
      return true;
    }

    validateGiftDetails() {
      if (!this.giftDrawer) return false;

      const self = this;
      let valid = true;
      let firstInvalid = null;

      this.giftDrawer.querySelectorAll('[data-gift-detail]').forEach(function (input) {
        self.normalizeGiftField(input);
        if (!self.validateGiftField(input)) {
          valid = false;
          if (!firstInvalid) firstInvalid = input;
        }
      });

      if (!valid) {
        this.showGiftDetails(false);
        if (firstInvalid) firstInvalid.focus();
        return false;
      }

      this.giftDrawer.querySelectorAll('[data-gift-detail]:not([data-gift-required])').forEach(function (el) {
        el.disabled = !String(el.value || '').trim();
      });

      return true;
    }

    syncPurchaseTypeUI() {
      const isSubscription = this.isSubscription();
      const purchaseMode = isSubscription ? 'subscription' : 'one_time';

      this.setAttribute('data-purchase-mode', purchaseMode);
      this.refreshPackageItems();
      this.ensureValidPackageSelection();
      this.syncVariantIdToForm();

      if (this.deliveryFieldset) {
        this.deliveryFieldset.classList.toggle('is-hidden', !isSubscription || this.isGiftMode());
      }

      this.syncUpsellVisibility();
      this.updateUpsellPrices();
      this.updateCardStates();
    }

    ensureValidPackageSelection() {
      this.variantSelects = this.getActiveVariantSelects();
      this.refreshPackageItems();
      if (!this.variantSelects) return;

      const isSubscription = this.isSubscription();
      const isGift = this.isGiftMode();
      const lockPackage = this.getLockPackage();
      const filterPackages = isSubscription || isGift || Boolean(lockPackage);
      let checkedInput = null;
      let needsReselect = false;
      const self = this;

      Array.from(this.packageItems).forEach(function (item) {
        const input = item.querySelector('[data-package-input]');
        if (!input) return;

        const availableForSubscription = item.dataset.availableForSubscription === 'true';
        const matchesLock = self.packageMatchesLock(item);
        const allowPackage = matchesLock && (
          Boolean(lockPackage)
          || !filterPackages
          || availableForSubscription
        );

        if (filterPackages && !allowPackage) {
          if (input.checked) {
            needsReselect = true;
          }
          input.checked = false;
          input.disabled = true;
          item.classList.add('is-hidden');
          return;
        }

        item.classList.remove('is-hidden');
        input.disabled = false;
        if (input.checked) {
          checkedInput = input;
        }
      });

      if (!filterPackages) {
        return;
      }

      if (!checkedInput || needsReselect) {
        const defaultPackage = Array.from(this.packageItems).find(function (item) {
          if (!self.packageMatchesLock(item)) return false;
          if (item.classList.contains('is-hidden')) return false;
          return item.dataset.defaultPackage === 'true';
        });
        const visiblePackage = Array.from(this.packageItems).find(function (item) {
          if (!self.packageMatchesLock(item)) return false;
          if (item.classList.contains('is-hidden')) return false;
          if (lockPackage) return true;
          return item.dataset.availableForSubscription === 'true';
        });
        const preferred = defaultPackage || visiblePackage;

        if (preferred) {
          const input = preferred.querySelector('[data-package-input]');
          if (input && !input.disabled) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }

    syncVariantIdToForm() {
      const variant = this.getCurrentVariant();
      if (!variant) return;

      const form = document.getElementById('product-form-' + this.sectionId);
      const idInput = form && form.querySelector('input[name="id"]');
      if (idInput && String(idInput.value) !== String(variant.id)) {
        idInput.value = String(variant.id);
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (idInput) {
        idInput.disabled = !variant.available;
      }

      this.variantSelects = this.getActiveVariantSelects();
      const selectedVariantScript = this.variantSelects
        && this.variantSelects.querySelector('[data-selected-variant]');
      if (selectedVariantScript) {
        try {
          selectedVariantScript.textContent = JSON.stringify(variant);
        } catch (error) {
          // Ignore serialization errors.
        }
      }

      this.syncBuyButtonAvailability();
    }

    syncBuyButtonAvailability() {
      const variant = this.getCurrentVariant();
      const form = document.getElementById('product-form-' + this.sectionId);
      const formWrapper = form && (form.closest('.form__wrapper') || form.closest('[data-form-wrapper]'));
      const button = document.getElementById('ProductSubmitButton-' + this.sectionId);
      const available = Boolean(variant && variant.available);
      const isClaim = this.isClaimGiftMode();

      if (formWrapper) {
        formWrapper.classList.toggle('variant--soldout', !available);
        formWrapper.classList.toggle('variant--unavailable', !variant);
      }

      if (!button) return;

      const textEl = button.querySelector('[data-add-to-cart-text]');
      const soldOutLabel = (window.theme && window.theme.strings && window.theme.strings.soldOut)
        || 'Sold out';
      const addLabel = (window.theme && window.theme.strings && window.theme.strings.addToCart)
        || 'Add to cart';
      const claimLabel = isClaim ? (this.dataset.claimAtcLabel || '') : '';

      if (!this.defaultAtcText) {
        this.defaultAtcText = textEl ? textEl.textContent.trim() : addLabel;
      }

      button.disabled = !available;
      button.setAttribute('aria-disabled', available ? 'false' : 'true');

      if (textEl) {
        if (!available) {
          textEl.textContent = soldOutLabel;
          button.classList.remove('is-claim-cta');
        } else if (claimLabel) {
          textEl.textContent = claimLabel;
          button.classList.add('is-claim-cta');
        } else {
          textEl.textContent = this.defaultAtcText || addLabel;
          button.classList.remove('is-claim-cta');
        }
      }
    }

    getCurrentVariant() {
      this.variantSelects = this.getActiveVariantSelects();
      const selectedOptions = getSelectedOptions(this);
      const fromOptions = findVariantForOptions(this.variants, selectedOptions, this.variantSelects);
      if (fromOptions) return fromOptions;

      const form = document.getElementById('product-form-' + this.sectionId);
      const idInput = form && form.querySelector('input[name="id"]');
      if (idInput && idInput.value) {
        return this.variants.find(function (variant) {
          return String(variant.id) === String(idInput.value);
        }) || null;
      }

      return null;
    }

    updateCardStates() {
      this.querySelectorAll('.product-information__card').forEach(function (card) {
        const inputId = card.getAttribute('for');
        if (!inputId) return;

        const input = document.getElementById(inputId);
        if (!input) return;

        card.classList.toggle('product-information__card--selected', input.checked);
      });
    }

    getAllocationForPlan(variantId, planId) {
      const plans = this.sellingPlansMap[String(variantId)] || [];
      return plans.find(function (plan) {
        return String(plan.id) === String(planId);
      });
    }

    getSelectedDeliveryPlanId() {
      const checked = this.querySelector('[data-delivery-input]:checked');
      return checked ? checked.value : null;
    }

    getSelectedPackageItem() {
      const input = this.querySelector('[data-package-input]:checked');
      return input ? input.closest('[data-package-value]') : null;
    }

    getSelectedPackCount() {
      const item = this.getSelectedPackageItem();
      return item ? this.getPackCountForItem(item) : 0;
    }

    getRecommendedWeeks() {
      const locked = this.getLockDeliveryWeeks();
      if (locked) return locked;

      const item = this.getSelectedPackageItem();
      if (item) {
        const fromData = parseInt(item.dataset.recommendedWeeks, 10);
        if (fromData > 0) return fromData;
        return recommendedWeeksFromPackCount(this.getPackCountForItem(item));
      }
      return 2;
    }

    getDeliveryWeeks(input) {
      if (!input) return 0;
      const fromData = parseInt(input.dataset.deliveryWeeks, 10);
      if (fromData > 0) return fromData;
      return parseWeeksFromPlanName(input.dataset.sellingPlanName || '');
    }

    sortDeliveryGrid() {
      const self = this;
      const grid = this.querySelector('[data-delivery-grid]');
      if (!grid) return;

      Array.from(grid.querySelectorAll('.product-information__delivery-item'))
        .sort(function (a, b) {
          const weeksA = parseInt(a.dataset.deliveryWeeks, 10)
            || self.getDeliveryWeeks(a.querySelector('[data-delivery-input]'))
            || 99;
          const weeksB = parseInt(b.dataset.deliveryWeeks, 10)
            || self.getDeliveryWeeks(b.querySelector('[data-delivery-input]'))
            || 99;
          return weeksA - weeksB;
        })
        .forEach(function (item) {
          const weeks = parseInt(item.dataset.deliveryWeeks, 10)
            || self.getDeliveryWeeks(item.querySelector('[data-delivery-input]'))
            || 99;
          item.style.order = String(weeks);
          grid.appendChild(item);
        });
    }

    findRecommendedDeliveryInput(weeks, plans) {
      const self = this;
      let inputs = Array.from(this.querySelectorAll('[data-delivery-input]'));

      if (plans && plans.length) {
        inputs = inputs.filter(function (input) {
          return plans.some(function (plan) {
            return String(plan.id) === String(input.value);
          });
        });
      }

      if (!inputs.length) return null;

      const exact = inputs.find(function (input) {
        return self.getDeliveryWeeks(input) === weeks;
      });
      if (exact) return exact;

      const ranked = inputs
        .map(function (input) {
          return { input: input, weeks: self.getDeliveryWeeks(input) };
        })
        .filter(function (entry) {
          return entry.weeks > 0;
        });

      const higher = ranked
        .filter(function (entry) {
          return entry.weeks >= weeks;
        })
        .sort(function (a, b) {
          return a.weeks - b.weeks;
        })[0];
      if (higher) return higher.input;

      const smallest = ranked.sort(function (a, b) {
        return a.weeks - b.weeks;
      })[0];

      return (smallest && smallest.input) || inputs[0];
    }

    updateDeliveryRecommendedBadges() {
      const locked = this.getLockDeliveryWeeks();
      const weeks = this.getRecommendedWeeks();
      const self = this;

      this.querySelectorAll('[data-delivery-input]').forEach(function (input) {
        const item = input.closest('.product-information__delivery-item');
        const badge = item && item.querySelector('[data-delivery-recommended]');
        if (!badge) return;
        if (locked) {
          badge.classList.add('is-hidden');
          return;
        }
        badge.classList.toggle('is-hidden', self.getDeliveryWeeks(input) !== weeks);
      });
    }

    formatGiftFrequency(weeks) {
      const template = this.dataset.giftFrequencyTemplate
        || (this.giftDrawer && this.giftDrawer.dataset.giftFrequencyTemplate)
        || 'Delivery every __COUNT__ weeks';
      return String(template).replace(/__COUNT__/g, String(weeks));
    }

    syncGiftFrequencyNote() {
      const text = this.formatGiftFrequency(this.getRecommendedWeeks());
      const note = this.querySelector('[data-gift-frequency-note]');
      if (note) note.textContent = text;
      if (this.giftDrawer) this.giftDrawer.dataset.giftFrequency = text;
    }

    updateDeliverySelection() {
      if (this.isSubscription()) {
        const variant = this.getCurrentVariant();
        const planId = this.resolveRecurringPlanId(
          this.getSelectedDeliveryPlanId(),
          variant && variant.id
        );
        this.setSellingPlanValue(planId);
      } else {
        this.setSellingPlanValue('');
      }

      this.updateCardStates();
      this.updatePackagePrices();
      this.updateUpsellPrices();
      this.updateMainPrice();
    }

    syncSellingPlanForVariant() {
      this.lockDeliveryOptions();
      this.updateDeliveryRecommendedBadges();
      this.syncGiftFrequencyNote();
      this.syncVariantIdToForm();

      const variant = this.getCurrentVariant();

      if (this.isClaimGiftMode()) {
        if (!variant) return;
        const months = this.getClaimGiftMonths();
        const planId = this.findClaimSellingPlanId(variant.id, months);
        this.setSellingPlanValue(planId);
        this.updateCardStates();
        this.updatePackagePrices();
        this.updateMainPrice();
        this.sortDeliveryGrid();
        this.syncClaimAtc();
        return;
      }

      if (this.isGiftMode()) {
        if (!variant) return;
        const months = this.getSelectedGiftMonths();
        const planId = this.findClaimSellingPlanId(variant.id, months);
        this.setSellingPlanValue(planId);
        this.updateCardStates();
        this.updatePackagePrices(months);
        this.updateMainPrice();
        this.syncClaimAtc();
        return;
      }

      if (!this.isSubscription()) {
        this.setSellingPlanValue('');
        this.updateMainPrice();
        return;
      }

      if (!variant) return;

      const plans = this.sellingPlansMap[String(variant.id)] || [];
      let planId = this.getSelectedDeliveryPlanId();
      const packCount = this.getSelectedPackCount();
      const packChanged = this._lastPackCount == null || this._lastPackCount !== packCount;
      this._lastPackCount = packCount;

      const planValid = planId && plans.some(function (plan) {
        return String(plan.id) === String(planId);
      });

      if (!planValid || packChanged || this.getLockDeliveryWeeks()) {
        const recommendedInput = this.findRecommendedDeliveryInput(this.getRecommendedWeeks(), plans);
        if (recommendedInput) {
          recommendedInput.checked = true;
          planId = recommendedInput.value;
        } else {
          planId = plans.length ? String(plans[0].id) : '';
          const fallbackInput = this.querySelector('[data-delivery-input][value="' + planId + '"]');
          if (fallbackInput) fallbackInput.checked = true;
        }
      }

      this.setSellingPlanValue(this.resolveRecurringPlanId(planId, variant.id));
      this.updateCardStates();
      this.updateMainPrice();
      this.sortDeliveryGrid();
      this.syncClaimAtc();
    }

    updatePackagePrices(giftMonthsOverride) {
      const self = this;
      const isSubscription = this.isSubscription();
      const isGiftPricing = this.isGiftMode() && Boolean(this.querySelector('[data-gift-length-fieldset]'));
      this.variantSelects = this.getActiveVariantSelects();
      this.refreshPackageItems();
      const selectedOptions = getSelectedOptions(this);
      const giftMonths = parseInt(giftMonthsOverride, 10) || this.getSelectedGiftMonths();

      this.packageItems.forEach(function (item) {
        const packageInput = item.querySelector('[data-package-input]');
        const priceEl = item.querySelector('[data-package-price]');
        const compareEl = item.querySelector('[data-package-compare-price]');
        const saveEl = item.querySelector('[data-package-save-badge]');

        if (!packageInput || !priceEl) return;

        let price = null;
        let compareAt = null;

        if (isGiftPricing) {
          const giftPricing = self.getGiftPackagePricing(item.dataset.packageValue, giftMonths);
          if (giftPricing) {
            price = giftPricing.price;
            compareAt = giftPricing.compareAt;
          }
        }

        if (price == null) {
          const variant = getVariantForPackageValue(
            self.variants,
            item.dataset.packageValue,
            selectedOptions,
            self.variantSelects,
            packageInput
          );

          if (!variant) return;

          price = variant.price;
          compareAt = variant.compare_at_price;

          if (!isGiftPricing && isSubscription) {
            const planId = self.getSelectedDeliveryPlanId();
            const allocation = self.getAllocationForPlan(variant.id, planId) || (self.sellingPlansMap[String(variant.id)] || [])[0];

            if (allocation) {
              price = allocation.price;
              compareAt = allocation.compare_at_price || variant.price;
            }
          }
        }

        priceEl.textContent = formatMoney(price, self.moneyFormat);

        if (compareEl) {
          if (compareAt && compareAt > price) {
            compareEl.textContent = formatMoney(compareAt, self.moneyFormat);
            compareEl.classList.remove('is-hidden');
          } else {
            compareEl.textContent = '';
            compareEl.classList.add('is-hidden');
          }
        }

        if (saveEl && self.dataset.showPackageSaveBadge === 'true') {
          if (compareAt && compareAt > price) {
            const savings = formatMoney(compareAt - price, self.moneyFormat);
            const template = self.dataset.saveBadgeTemplate || 'Save __AMOUNT__';
            saveEl.textContent = template.replace('__AMOUNT__', savings);
            saveEl.classList.remove('is-hidden');
          } else {
            saveEl.textContent = '';
            saveEl.classList.add('is-hidden');
          }
        }
      });

      this.updatePackageSummaries();
    }

    getSelectedSizeInput() {
      this.variantSelects = this.getActiveVariantSelects();
      if (!this.variantSelects) return null;

      return this.variantSelects.querySelector('[data-size-input]:checked')
        || this.variantSelects.querySelector('[data-size-input]');
    }

    getSizeStats() {
      const sizeInput = this.getSelectedSizeInput();
      if (!sizeInput) return null;

      const sizeKey = normalizeSizeKey(sizeInput.dataset.sizeKey || sizeInput.value);
      const defaults = DEFAULT_SIZE_STATS[sizeKey] || null;
      const pieces = parseInt(sizeInput.dataset.piecesPerPack, 10) || (defaults && defaults.pieces) || null;
      const daily = parseFloat(sizeInput.dataset.dailyUsage) || (defaults && defaults.daily) || null;

      if (!pieces || !daily) return null;

      return { sizeKey: sizeKey, pieces: pieces, daily: daily };
    }

    getPackCountForItem(item) {
      const fromData = parseInt(item.dataset.packCount, 10);
      if (fromData > 0) return fromData;

      const label = item.dataset.packageValue
        || (item.querySelector('.product-information__title-md') || {}).textContent
        || '';

      return inferPackCount(label);
    }

    formatPackageSummary(totalPieces, days, item) {
      const diapersLabel = this.dataset.summaryDiapers || 'diapers';
      const daysLabel = this.dataset.summaryDays || 'days';

      return this.appendMostPopular(
        totalPieces + ' ' + diapersLabel + ' · ±' + days + ' ' + daysLabel,
        item
      );
    }

    appendMostPopular(text, item) {
      // Most popular is shown as a permanent badge on the package card.
      // Keep this helper as a no-op so selected summaries stay clean.
      return text || '';
    }

    updatePackageSummaries() {
      const self = this;
      const sizeStats = this.getSizeStats();

      this.packageItems.forEach(function (item) {
        const summaryEl = item.querySelector('[data-package-summary]');
        if (!summaryEl) return;

        const packCount = self.getPackCountForItem(item);
        const canCalculate = sizeStats && packCount;

        if (!canCalculate) {
          const fallback = summaryEl.dataset.packageSummaryFallback;
          if (fallback) {
            summaryEl.textContent = self.appendMostPopular(fallback, item);
            summaryEl.classList.remove('is-hidden');
          } else {
            const popularOnly = self.appendMostPopular('', item);
            if (popularOnly) {
              summaryEl.textContent = popularOnly;
              summaryEl.classList.remove('is-hidden');
            } else {
              summaryEl.textContent = '';
              summaryEl.classList.add('is-hidden');
            }
          }
          return;
        }

        const totalPieces = sizeStats.pieces * packCount;
        const days = Math.max(1, Math.floor(totalPieces / sizeStats.daily));
        summaryEl.textContent = self.formatPackageSummary(totalPieces, days, item);
        summaryEl.classList.remove('is-hidden');
      });
    }

    updateMainPrice() {
      const variant = this.getCurrentVariant();
      if (!variant || !window.theme) return;

      let price = variant.price;
      let compareAt = variant.compare_at_price;

      if (this.isClaimGiftMode() || this.isGiftMode()) {
        // Prepaid gift totals live on the variant; plan allocations can be per-cycle.
        price = variant.price;
        compareAt = variant.compare_at_price;
      } else if (this.isSubscription()) {
        const planId = this.getSelectedDeliveryPlanId();
        const allocation = this.getAllocationForPlan(variant.id, planId);

        if (allocation) {
          price = allocation.price;
          compareAt = allocation.compare_at_price || variant.price;
        }
      }

      const formattedPrice = formatMoney(price, this.moneyFormat);
      const onSale = compareAt && compareAt > price;
      const formattedCompare = onSale ? formatMoney(compareAt, this.moneyFormat) : '';

      document.querySelectorAll('cart-bar [data-product-price]').forEach(function (el) {
        el.textContent = formattedPrice;
        el.classList.toggle('product__price--sale', onSale);
      });

      document.querySelectorAll('cart-bar .product__price--strike').forEach(function (el) {
        el.textContent = onSale ? formattedCompare : '';
      });
    }
  }

  if (!customElements.get('product-information-block')) {
    customElements.define('product-information-block', ProductInformationBlock);
  }
})();
